import './PendingStructuresInvitation.scss';

import { Box, Divider } from '@mui/material';
import { RolesStructureEnum } from 'domain/security/RolesStructureEnum';
import { StructureMember } from 'domain/structureMember/StructureMember';
import { KeyValue } from 'primary/Components/KeyValue/KeyValue';
import { TagPlayer } from 'primary/Components/TagPlayer/TagPlayer';
import { useContextDependency } from 'primary/hooks/useContextDependency';
import { useTranslate } from 'primary/hooks/useTranslate';
import { ActionButtonsForContent } from 'primary/MessageList/contents/ActionButtonsForContent';
import {
  getOnClickResponseStructureInvitation,
  getOnClickSeeStructure,
} from 'primary/MessageList/contents/NotificationInvitationStructureContent';
import ModalContainer from 'primary/ModalContainer/ModalContainer';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

type ModalPendingStructureInvitationProps = {
  isOpen?: boolean;
  handleClose: () => void;
  invitationList: StructureMember[];
  afterSubmit: () => void;
  loading?: boolean;
};

export const ModalPendingStructureInvitation = ({
  isOpen,
  handleClose,
  afterSubmit,
  invitationList,
  loading,
}: ModalPendingStructureInvitationProps) => {
  const t = useTranslate();
  return (
    <ModalContainer
      handleClose={handleClose}
      isOpen={!!isOpen}
      header={{
        title: t('modals.pendingStructureInvitation.title'),
        withButtonClose: true,
      }}
      content={
        <Box className={'modal-pending-structure-invitation'}>
          <ListPendingStructureInvitation
            invitationList={invitationList}
            afterSubmit={afterSubmit}
            loadingFromButton={loading}
          />
        </Box>
      }
    />
  );
};

type ListPendingStructureInvitationProps = {
  invitationList: StructureMember[];
  afterSubmit: () => void;
  loadingFromButton?: boolean;
};

const ListPendingStructureInvitation = ({
  invitationList,
  afterSubmit,
  loadingFromButton,
}: ListPendingStructureInvitationProps) => {
  const [loading, setLoading] = useState(false);
  const { structureMemberRepository, authRepository } = useContextDependency();
  const t = useTranslate();
  const navigate = useNavigate();
  return (
    <div className={'-listPendingStructureInvitation'}>
      {invitationList?.map((invitation) => {
        const chief = invitation.structure?.members?.find(
          (m) => m.role.code === RolesStructureEnum.PRES,
        )?.user.userProfil;
        return (
          <div key={invitation.structure?.id} className={'-pendingStructureInvitation'}>
            <div>
              {chief && authRepository?.currentUser?.userProfil.id === chief?.idProfil ? (
                <>
                  <TagPlayer player={invitation.user.userProfil} />
                  <span>Souhaite rejoindre votre structure</span>
                </>
              ) : (
                <>
                  <TagPlayer player={invitation.user.userProfil} />
                  <span>Vous invite à rejoindre sa structure</span>
                </>
              )}
            </div>
            <Divider />
            <div className={'-infos'}>
              <div className={'-structureInfos'}>
                <KeyValue
                  className={'-margedRight'}
                  accent
                  keyValue={'Structure :'}
                  value={invitation.structure?.name}
                />
                <KeyValue
                  className={'-margedRight'}
                  accent
                  keyValue={'Membres :'}
                  value={invitation.structure?.members?.length?.toString() ?? '0'}
                />
              </div>
            </div>
            <Divider />
            <div className={'-footerActions'}>
              <ActionButtonsForContent
                loading={loadingFromButton || loading}
                onClickExitTo={getOnClickSeeStructure(
                  navigate,
                  invitation.structure?.id?.toString() as string,
                )}
                onClickCancel={getOnClickResponseStructureInvitation(
                  structureMemberRepository,
                  invitation.user.id as number,
                  invitation.structure?.id as number,
                  t,
                  false,
                  afterSubmit,
                  setLoading,
                )}
                onClickValid={getOnClickResponseStructureInvitation(
                  structureMemberRepository,
                  invitation.user.id as number,
                  invitation.structure?.id as number,
                  t,
                  true,
                  afterSubmit,
                  setLoading,
                )}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
};
